import { render, staticRenderFns } from "./SystemMessageNew.vue?vue&type=template&id=2d82ba8a&scoped=true&"
import script from "./SystemMessageNew.vue?vue&type=script&lang=js&"
export * from "./SystemMessageNew.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageNew.vue?vue&type=style&index=0&id=2d82ba8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82ba8a",
  null
  
)

export default component.exports